export var ActivityType;
(function (ActivityType) {
    ActivityType["PHONE_CALL"] = "phone_call";
    ActivityType["TEXT_MESSAGE"] = "text_message";
    ActivityType["EXTERNAL_EMAIL"] = "external_email";
})(ActivityType || (ActivityType = {}));
export const ActivityTypeLabels = {
    [ActivityType.PHONE_CALL]: `Phone Call`,
    [ActivityType.TEXT_MESSAGE]: `Text Message`,
    [ActivityType.EXTERNAL_EMAIL]: `External Email`,
};
/** How a phone call went. Picked when logging a call, prefilled by click to call */
export var CallOutcome;
(function (CallOutcome) {
    CallOutcome["NO_ANSWER"] = "no_answer";
    CallOutcome["LEFT_VOICEMAIL"] = "left_voicemail";
    CallOutcome["SPOKE_TO_CUSTOMER"] = "spoke_to_customer";
    CallOutcome["WRONG_NUMBER"] = "wrong_number";
    CallOutcome["NOT_AVAILABLE"] = "not_available";
    CallOutcome["CALL_FAILED"] = "call_failed";
    CallOutcome["CALLBACK_REQUESTED"] = "callback_requested";
    CallOutcome["OTHER"] = "other";
})(CallOutcome || (CallOutcome = {}));
export const CallOutcomeLabels = {
    [CallOutcome.NO_ANSWER]: `No answer`,
    [CallOutcome.LEFT_VOICEMAIL]: `Left a voicemail`,
    [CallOutcome.SPOKE_TO_CUSTOMER]: `Spoke to customer`,
    [CallOutcome.WRONG_NUMBER]: `Wrong number`,
    [CallOutcome.NOT_AVAILABLE]: `Not available`,
    [CallOutcome.CALL_FAILED]: `Call failed`,
    [CallOutcome.CALLBACK_REQUESTED]: `Callback requested`,
    [CallOutcome.OTHER]: `Other`,
};
/**
 * What can be recorded from a call. The AI summary suggests promises, queries and plans on an invoice. A follow up
 * email is drafted and sent from the call afterwards, and is not tied to an invoice
 */
export var CallFollowUpType;
(function (CallFollowUpType) {
    CallFollowUpType["PAYMENT_PROMISE"] = "payment_promise";
    CallFollowUpType["INVOICE_QUERY"] = "invoice_query";
    CallFollowUpType["PAYMENT_PLAN"] = "payment_plan";
    CallFollowUpType["FOLLOW_UP_EMAIL"] = "follow_up_email";
})(CallFollowUpType || (CallFollowUpType = {}));
export const CallFollowUpTypeLabels = {
    [CallFollowUpType.PAYMENT_PROMISE]: `Payment promise`,
    [CallFollowUpType.INVOICE_QUERY]: `Invoice query`,
    [CallFollowUpType.PAYMENT_PLAN]: `Payment plan`,
    [CallFollowUpType.FOLLOW_UP_EMAIL]: `Follow up email`,
};
/** Demo stack only (PAIDNICE_DEMO): canned click to call conversations, picked on the pre call screen */
export var DemoCallScenario;
(function (DemoCallScenario) {
    DemoCallScenario["PROMISE_NAMED"] = "promise_named";
    DemoCallScenario["PROMISE_UNNAMED"] = "promise_unnamed";
    DemoCallScenario["INVOICE_QUERY"] = "invoice_query";
    DemoCallScenario["PAYMENT_PLAN"] = "payment_plan";
    DemoCallScenario["PROMISE_AND_QUERY"] = "promise_and_query";
    DemoCallScenario["CALLBACK"] = "callback";
    DemoCallScenario["VOICEMAIL"] = "voicemail";
    DemoCallScenario["WRONG_NUMBER"] = "wrong_number";
    DemoCallScenario["NOT_AVAILABLE"] = "not_available";
})(DemoCallScenario || (DemoCallScenario = {}));
export const DemoCallScenarioLabels = {
    [DemoCallScenario.PROMISE_NAMED]: `Promise to pay, invoice named`,
    [DemoCallScenario.PROMISE_UNNAMED]: `Promise to pay, no invoice named`,
    [DemoCallScenario.INVOICE_QUERY]: `Invoice query, never received`,
    [DemoCallScenario.PAYMENT_PLAN]: `Payment plan, weekly`,
    [DemoCallScenario.PROMISE_AND_QUERY]: `Promise and a query`,
    [DemoCallScenario.CALLBACK]: `Callback requested`,
    [DemoCallScenario.VOICEMAIL]: `Left a voicemail`,
    [DemoCallScenario.WRONG_NUMBER]: `Wrong number`,
    [DemoCallScenario.NOT_AVAILABLE]: `Not available`,
};
/** e.g. "Phone Call (No answer)" */
export function activityLabel(type, callOutcome) {
    const label = ActivityTypeLabels[type] || type;
    return callOutcome ? `${label} (${CallOutcomeLabels[callOutcome] || callOutcome})` : label;
}
//# sourceMappingURL=activity.js.map